import { Box, Button, Card, Link, Typography } from "@mui/material";
import React, { useMemo } from "react";
import ErrorBoundary from "../../components/shared/ErrorBoundary/ErrorBoundary";

const Logout = () => {
  const loginUrl = useMemo(() => {
    const env = typeof process !== "undefined" ? process.env : {};
    const envLogin = env?.REACT_APP_LOGIN_URL;
    const redirect = env?.REACT_APP_REDIRECT_URI;
    return envLogin || redirect || `${window.location.origin}/login`;
  }, []);

  const handleRelogin = () => {
    window.location.href = loginUrl;
  };

  return (
    <ErrorBoundary>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
          padding: 2,
        }}
      >
        <Card
          elevation={8}
          sx={{
            maxWidth: 480,
            width: "100%",
            padding: 4,
            textAlign: "center",
            borderRadius: 3,
            background: "rgba(255,255,255,0.96)",
            backdropFilter: "blur(4px)",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Successfully logged out
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
            You have successfully logged out from the Riva. Please log in again to continue.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mb: 2 }}
            onClick={handleRelogin}
          >
            Login Again
          </Button>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Login URL:{" "}
            <Link href={loginUrl} underline="hover">
              {loginUrl}
            </Link>
          </Typography>
        </Card>
      </Box>
    </ErrorBoundary>
  );
};

export default Logout;
